import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { environment } from 'src/environments/environment';
import { MotoresTransmissaoTimeTableModel } from 'src/app/models/MotoresTransmissaoTimeTable';
import { MotoresTransmissaoTripsModel } from 'src/app/models/MotoresTransmissaoResponse';
import { MotoresTransmissaoUpdateModel } from 'src/app/models/MotoresTransmissaoUpdateModel';
import { DocksModel } from 'src/app/models/DocksModel';

@Injectable({
  providedIn: 'root'
})
export class MotoresTransmissaoService {

  apiLink = environment.apiLink;
  httpOption = httpOptions

  constructor(private readonly http: HttpClient) { }

  // TIME-TABLE METHODS

  getAllTrips(): Observable<MotoresTransmissaoTimeTableModel[]> {
    return this.http.get<MotoresTransmissaoTimeTableModel[]>(`${this.apiLink}/EngineAndTransmission/TimeTable`)
  }

  getTripById(id: number): Observable<MotoresTransmissaoTimeTableModel> {
    return this.http.get<MotoresTransmissaoTimeTableModel>(`${this.apiLink}/EngineAndTransmission/TimeTable/${id}`)
  }

  createTrip(request: MotoresTransmissaoTimeTableModel) {
    return this.http.post(`${this.apiLink}/EngineAndTransmission/TimeTable`, request)
  }

  updateTrip(request: MotoresTransmissaoTimeTableModel, id: number) {
    return this.http.put(`${this.apiLink}/EngineAndTransmission/TimeTable/${id}`, request)
  }

  deleteTrip(id: number): Observable<any> {
    return this.http.delete(`${environment.apiLink}/EngineAndTransmission/TimeTable/${id}`);
  }

  // AUXILIARY TAKT METHODS

  getActiveTrips(): Observable<MotoresTransmissaoTripsModel[]> {
    return this.http.get<MotoresTransmissaoTripsModel[]>(`${this.apiLink}/EngineAndTransmission/Trips`)
  }

  getActiveTripsView(): Observable<MotoresTransmissaoTripsModel[]> {
    return this.http.get<MotoresTransmissaoTripsModel[]>(`${this.apiLink}/View/EngineAndTransmission/Trips`)
  }

  updateEngineAndTransmissionTripsTable(request: MotoresTransmissaoUpdateModel) {
    return this.http.put(`${this.apiLink}/EngineAndTransmission/Trips`, request)
  }

  // VIEW METHODS

  getEngineAndTransmissionDocksDataView(): Observable<DocksModel[]> {
    return this.http.get<DocksModel[]>(`${this.apiLink}/View/EngineAndTransmission/Docks`, httpOptions)
  }

  getTripByIdView(id: number): Observable<MotoresTransmissaoTimeTableModel> {
    return this.http.get<MotoresTransmissaoTimeTableModel>(`${this.apiLink}/View/EngineAndTransmission/TimeTable/${id}`)
  }
}
